export default __webpack_public_path__ + "static/playing-c543ab1f5fd1617e561b41d7566c33e5.gif";